import React, { useContext } from "react";
import withStyles from "components/common/wrappers/withStyles";
import { ServerNotificationsContext } from "components/common";

const BellWithNotification = ({ color }) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33333 14H6.66666M9.16488 1.5067C8.79061 1.39276 8.39837 1.33333 7.99999 1.33333C6.93913 1.33333 5.92173 1.75476 5.17158 2.50491C4.42143 3.25505 4.00001 4.27247 4.00001 5.33333C4.00001 7.39347 3.48032 8.804 2.89978 9.73693C2.41009 10.5239 2.16525 10.9174 2.17422 11.0272C2.18417 11.1487 2.20991 11.1951 2.30785 11.2677C2.39631 11.3333 2.79507 11.3333 3.59257 11.3333H12.4075C13.2049 11.3333 13.6037 11.3333 13.6921 11.2677C13.7901 11.1951 13.8159 11.1487 13.8258 11.0272C13.8348 10.9174 13.5899 10.5239 13.1003 9.73693C12.911 9.43289 12.7283 9.07812 12.5679 8.66667"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6667 4.66667C14.6667 6.13943 13.4728 7.33333 12 7.33333C10.5273 7.33333 9.33334 6.13943 9.33334 4.66667C9.33334 3.19391 10.5273 2 12 2C13.4728 2 14.6667 3.19391 14.6667 4.66667Z"
        fill="#E25153"
      />
    </svg>
  );
};

const BellPlain = ({ color }) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.33333 14H6.66666M12 5.33333C12 4.27246 11.5786 3.25505 10.8285 2.5049C10.0783 1.75475 9.06086 1.33333 7.99999 1.33333C6.93913 1.33333 5.92173 1.75475 5.17158 2.5049C4.42143 3.25505 4.00001 4.27246 4.00001 5.33333C4.00001 7.39346 3.48032 8.804 2.89978 9.73693C2.41009 10.5239 2.16525 10.9174 2.17422 11.0272C2.18417 11.1487 2.20991 11.1951 2.30785 11.2677C2.39631 11.3333 2.79507 11.3333 3.59257 11.3333H12.4075C13.2049 11.3333 13.6037 11.3333 13.6921 11.2677C13.7901 11.1951 13.8159 11.1487 13.8258 11.0272C13.8348 10.9174 13.5899 10.5239 13.1003 9.73693C12.5197 8.804 12 7.39346 12 5.33333Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Bell = ({ color }) => {
  const { getNotifications } = useContext(ServerNotificationsContext);
  const hasUnseenNotifications = getNotifications({ read: false }).length;
  return hasUnseenNotifications ? (
    <BellWithNotification color={color} />
  ) : (
    <BellPlain color={color} />
  );
};

Bell.defaultProps = {
  color: "white",
};

export default withStyles(Bell);
